/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import classes from "./MyMaorModal.module.scss";

const MyMaorModal = ({ isOpen, onClose, title, children }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div className={classes.overlay} onClick={handleOverlayClick}>
      <div className={classes.modal}>
        <button className={classes.closeBtn} onClick={onClose} aria-label="Close">
          ✕
        </button>
        {title && <h1 className={classes.title}>{title}</h1>}
        <div className={classes.content}>{children}</div>
      </div>
    </div>
  );
};

export default MyMaorModal;
